import styled from '@emotion/styled';

// alignStart: sits flush under a section heading instead of centering across the container.
export const StateWrapper = styled.div<{ alignStart?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ alignStart }) => (alignStart ? 'flex-start' : 'center')};
    gap: 12px;
    padding: ${({ alignStart }) => (alignStart ? '0' : '32px 16px')};
    text-align: ${({ alignStart }) => (alignStart ? 'left' : 'center')};
    color: #6b7280;
    font-size: 13px;
`;

export const ErrorMessage = styled.div`
    color: #991b1b;
`;

export const RefetchOverlayWrapper = styled.div`
    position: relative;
`;

export const RefetchOverlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
`;

// Fixed to the viewport, not the overlay, so the spinner stays centered on screen even when the
// table is taller than the viewport and the overlay itself extends well past what's visible.
export const RefetchSpinnerWrap = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
